// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bfz_a"};